import React from "react";
import PropTypes from "prop-types";

import { Icon, Message, Money } from "..";

function CouponMessage({
  code,
  discountAmount,
  discountDetails,
  currency,
  loading,
  onDismiss,
  children,
}) {
  return (
    <Message data-test="coupon-information" icon info onDismiss={onDismiss}>
      <Icon
        data-test="coupon-information-icon"
        name={loading ? "circle notched" : "tag"}
        loading={loading}
      />
      <Message.Content>
        <Message.Header>{code}</Message.Header>
        <div>
          <div style={{ fontSize: "90%" }}>
            <i>{discountDetails}</i>
          </div>
          A total of discount of{" "}
          <b>
            <Money currency={currency}>{discountAmount}</Money>
          </b>{" "}
          has been applied to your updated subscription and the total price
          shown above.
        </div>
        {children}
      </Message.Content>
    </Message>
  );
}

CouponMessage.propTypes = {
  code: PropTypes.string,
  discountAmount: PropTypes.string,
  discountDetails: PropTypes.string,
  currency: PropTypes.string,
  loading: PropTypes.bool,
  onDismiss: PropTypes.func,
  children: PropTypes.node,
};

CouponMessage.defaultProps = {
  code: "",
  discountAmount: "",
  discountDetails: "",
  currency: "USD",
  loading: false,
  onDismiss: undefined,
  children: undefined,
};

export default CouponMessage;
